import i18n from 'i18next'
import getRequestInstance from '@src/utils/axios'
import { getAccountInfo, setAccountInfo } from '@src/utils/jwt'
import { APIResponse } from '@src/types/common/api'

import { toast } from 'react-toastify'

const getToken = () => {
  const token = getAccountInfo()?.token
  return token ?? ''
}
// 根据 code 获取多语言错误消息
const getLocalizedErrorMessage = (code: number) => {
  const codeKey = `api_error.${code}`
  return i18n.exists(codeKey) ? i18n.t(codeKey) : ''
}

const responseHandler = (response: { data: APIResponse }): APIResponse => {
  if (response.data.code === 0) return response.data

  // 未授权的情况
  if (response.data.code === 401) {
    toast.error('Login has expired, please re-login')
    setTimeout(() => {
      window.location.href = '/'
      setAccountInfo(null)
    }, 1000)
  }

  // 获取多语言的错误消息
  const localizedMessage = getLocalizedErrorMessage(response.data.code)
  if (localizedMessage) {
    toast.error(localizedMessage)
  }
  console.error(localizedMessage)

  return response.data
}

const responseWebError = () => {
  toast.error('Network error')
  return { code: 1000000, data: null, msg: '' }
}

const request = getRequestInstance({ getToken, responseHandler, responseWebError })

export { request }
